import {atom} from "jotai";

export const ChatDrawerAtom = atom({
  open: false,
  startNode: null
})

export const ConfirmDialogAtom = atom({
  open: false,
  title: "",
  message: "",
})

export const DialAtom = atom(false);